var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwViewOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9019 16.0807C13.4842 16.9796 11.8028 17.5002 9.99993 17.5002C5.50644 17.5002 1.76813 14.267 0.984375 10.0002C1.34827 8.01904 2.34911 6.26077 3.76673 4.9455L1.16106 2.33983L2.33957 1.16132L18.8388 17.6604L17.6603 18.839L14.9019 16.0807ZM4.94601 6.12477C3.83862 7.13348 3.03117 8.47269 2.68533 10.0002C3.44986 13.3768 6.47018 15.8335 9.99993 15.8335C11.3328 15.8335 12.593 15.4832 13.6866 14.8654L11.9963 13.1751C11.4183 13.5394 10.7337 13.7502 9.99993 13.7502C7.92883 13.7502 6.24989 12.0712 6.24989 10.0002C6.24989 9.26636 6.46065 8.58177 6.82493 8.00371L4.94601 6.12477ZM10.7613 11.94L8.06006 9.23886C7.96742 9.47469 7.91656 9.73144 7.91656 10.0002C7.91656 11.1508 8.84934 12.0835 9.99993 12.0835C10.2686 12.0835 10.5254 12.0326 10.7613 11.94ZM17.3387 13.8271L16.1463 12.6348C16.6929 11.8557 17.0958 10.9655 17.3144 10.0002C16.5499 6.62351 13.5296 4.16682 9.99993 4.16682C9.29501 4.16682 8.61043 4.2648 7.96008 4.44851L6.64506 3.13348C7.68407 2.72468 8.81576 2.50016 9.99993 2.50016C14.4933 2.50016 18.2317 5.73329 19.0154 10.0002C18.7553 11.4165 18.1695 12.719 17.3387 13.8271ZM9.76876 6.25717C9.84518 6.25252 9.92226 6.25016 9.99993 6.25016C12.0709 6.25016 13.7499 7.92909 13.7499 10.0002C13.7499 10.0778 13.7475 10.1549 13.7429 10.2313L9.76876 6.25717Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwViewOff);
export default __webpack_public_path__ + "static/media/pw_view_off.37b3c4d1ffdbe80068263ab8417e4f4d.svg";
export { ForwardRef as ReactComponent };